import { Chart, ChartEvent, ChartType, InteractionItem, Plugin } from "chart.js";
import { MapAxisLabelEventOptions } from "./map-axis-label-event.options";
import { isNumber, isString } from 'lodash-es';
import { GeoFeature } from "chartjs-chart-geo";

class MapAxisLabelEventPlugin<T extends ChartType = ChartType, O = Record<string, unknown>> implements Plugin<T, O> {
    id: string = 'mapAxisLabelEventPlugin';

    private isNumberRegexp: RegExp = /^[+-]?([0-9]*[.])?[0-9]+$/;

    private numberFormatter =  Intl.NumberFormat('en-US', { maximumFractionDigits: 1 })

    private defaultConfig: MapAxisLabelEventOptions = {
      onLabelMouseMove: (label: string, event: ChartEvent, chart: Chart) => {},
      postfix: ''
    };

    beforeEvent(chart: Chart, args: { event: ChartEvent, replay: boolean, cancelable: true, inChartArea: boolean }, options: O): boolean | void {

      const event: ChartEvent = args.event;
      const opt: MapAxisLabelEventOptions = { ...this.defaultConfig, ...options };

      let label = null;

      if (event.type === 'mousemove') {
        if (args.inChartArea) {
          let hoverOptions = chart.options.hover;
          let intersections = chart.getElementsAtEventForMode(event.native, hoverOptions.mode, hoverOptions, false);
          if (intersections.length > 0) {
            let intersection: InteractionItem = intersections.pop();
            let element: GeoFeature = intersection.element as GeoFeature;
            let value = chart.data.datasets[0].data[intersection.index]['value'];
            label = `${element.feature?.properties?.name}: ${this.formatString(value)}${opt.postfix}`;
          }
        }
        opt.onLabelMouseMove(label, event, chart);
      } else if (event.type === 'mouseout') {
        opt.onLabelMouseMove(label, event, chart);
      }
    }

    private formatString(value: any): string {
      if (isString(value)) {
        let cleanStr = value.replace(',', '');
        return (this.isNumberRegexp.test(cleanStr) ? this.numberFormatter.format(parseFloat(cleanStr)) : value);
      } else if(isNumber(value)) {
        return this.numberFormatter.format(value);
      }
      return value;
    }
}

export const mapAxisLabelEventPlugin: Plugin = new MapAxisLabelEventPlugin();
